import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import renderTableExpandIcon from "./js/components/common/TableExpandButton";

import "./index.css";
import App from "./App";
import { initSentry } from "./js/dependencies/custom/sentry";
// import reportWebVitals from './reportWebVitals';

// Initialize Sentry as early as possible (no-op outside the test environment).
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ConfigProvider
      table={{ expandable: { expandIcon: renderTableExpandIcon } }}
    >
      <App />
    </ConfigProvider>
  </BrowserRouter>,
  // </React.StrictMode>
);

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
